module.exports = __webpack_public_path__ + "img/google-play-es.d799d31.png";